import {
  Checkbox,
  Image,
  View,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useMemo } from "react";
import { StyleSheet } from "react-native";

type ImageTileProps = {
  index: number;
  imageUrl: string;
  width: number;
  height: number;
  selected: boolean;
  onSelect: (index: number, selected: boolean) => void;
};

const baseImageStyle = {
  width: "100%",
  height: "100%",
  resizeMode: "cover",
} as const;

export function ImageTile({
  index,
  selected,
  imageUrl,
  width,
  height,
  onSelect,
}: ImageTileProps) {
  const { colors, spacings } = useThemeProvider();

  const imageMarkup = useMemo(
    () => (
      <Image
        resizeMode="cover"
        defaultSource={{ uri: imageUrl }}
        source={{ uri: imageUrl }}
        style={baseImageStyle}
      />
    ),
    [imageUrl]
  );

  return (
    <View
      style={[
        {
          width,
          height,
          aspectRatio: 1,
          borderColor: colors.borderColor,
          borderWidth: 2,
          borderRadius: spacings.s4,
          overflow: "hidden",
        },
      ]}
    >
      <View style={[styles.controls, { padding: spacings.s2, zIndex: 1 }]}>
        <Checkbox
          color={colors.primary}
          value={selected}
          onValueChange={(selected) => onSelect(index, selected)}
        />
      </View>
      {imageMarkup}
    </View>
  );
}

const styles = StyleSheet.create({
  controls: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
  },
});
